

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";

const stockAtomList = atom({key:'profile_atom', default:{module:[],
    profile:[], module_without_all:[]
}});


export  const SetPermissionProfileAtom = () => useSetRecoilState(stockAtomList);
export  const GetPermissionProfileAtom = () => useRecoilValue(stockAtomList);










